import { render, staticRenderFns } from "./TowelDryerDescription.vue?vue&type=template&id=726b54dc&scoped=true"
import script from "./TowelDryerDescription.vue?vue&type=script&lang=ts"
export * from "./TowelDryerDescription.vue?vue&type=script&lang=ts"
import style0 from "./TowelDryerDescription.vue?vue&type=style&index=0&id=726b54dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726b54dc",
  null
  
)

export default component.exports